var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10C12.2375 10 10 12.2375 10 15C10 17.7625 12.2375 20 15 20C17.7625 20 20 17.7625 20 15C20 12.2375 17.7625 10 15 10ZM26.175 13.75C25.8919 11.2152 24.7552 8.85192 22.9516 7.04837C21.1481 5.24481 18.7848 4.10814 16.25 3.825V1.25H13.75V3.825C11.2152 4.10814 8.85192 5.24481 7.04837 7.04837C5.24481 8.85192 4.10814 11.2152 3.825 13.75H1.25V16.25H3.825C4.10814 18.7848 5.24481 21.1481 7.04837 22.9516C8.85192 24.7552 11.2152 25.8919 13.75 26.175V28.75H16.25V26.175C18.7848 25.8919 21.1481 24.7552 22.9516 22.9516C24.7552 21.1481 25.8919 18.7848 26.175 16.25H28.75V13.75H26.175ZM15 23.75C10.1625 23.75 6.25 19.8375 6.25 15C6.25 10.1625 10.1625 6.25 15 6.25C19.8375 6.25 23.75 10.1625 23.75 15C23.75 19.8375 19.8375 23.75 15 23.75Z",
    fill: "#BC172F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a92dfc852459a152317d67c288a5dc75.svg";
export { ForwardRef as ReactComponent };